import React, { createContext, useContext, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const ListFocusContext = createContext();

export function ListFocusProvider({ children }) {
    const [focusedKey, setFocusedIndex] = useState(null);
    const [keyToIndex, setKeyToIndex] = useState({});
    const itemRefs = useRef({});
    const isobars = useSelector((state) => state.intermediateState.isobars);
    const isobarNames = Object.getOwnPropertyNames(isobars);


    const focusItem = (key) => {
        const index = isobarNames.indexOf(key);
        if (index >= 0 && itemRefs.current["ListRef"]) {
            itemRefs.current["ListRef"].scrollToIndex(index);
            setFocusedIndex(index);}
    };

    return (
        <ListFocusContext.Provider value={{ focusItem, itemRefs, focusedKey, setKeyToIndex }}>
            {children}
        </ListFocusContext.Provider>
    );
}

export const useListFocus = () => useContext(ListFocusContext);